import ActualitesList from './List';
import { ActualiteArticleList, ActualiteArticleCreate, ActualiteArticleEdit, ActualiteArticleShow } from './Article';
import { ActualiteRubriqueList, ActualiteRubriqueCreate, ActualiteRubriqueEdit } from './Rubrique';
import { TagCreate, TagEdit, TagList } from 'pages';

export const ActuList = (props) => <ActualitesList mode="articles" {...props} />;
export const ActuArticleList = (props) => <ActualiteArticleList mode="articles" {...props} />;
export const ActuArticleCreate = (props) => <ActualiteArticleCreate mode="articles" {...props} />;
export const ActuArticleEdit = (props) => <ActualiteArticleEdit mode="articles" {...props} />;
export const ActuRubriqueList = (props) => <ActualiteRubriqueList mode="articles" {...props} />;
export const ActuArticleShow = (props) => <ActualiteArticleShow mode="articles" {...props} />;
export const ActuRubriqueCreate = (props) => <ActualiteRubriqueCreate mode="articles" {...props} />;
export const ActuRubriqueEdit = (props) => <ActualiteRubriqueEdit mode="articles" {...props} />;
export const ActuTagCreate = (props) => <TagCreate backUrl="/actualites/tags" {...props} />;
export const ActuTagEdit = (props) => <TagEdit backUrl="/actualites/tags" {...props} />;
export const ActuTagList = (props) => (
    <TagList
        createUrl="/actualites/tags/create"
        editUrl={(t) => `/actualites/tags/edit/${t.id}`}
        backUrl="/actualites"
        {...props}
    />
);

export const DecryptRHList = (props) => <ActualitesList mode="decrypt_rhs" {...props} />;
export const DecryptRHArticleList = (props) => <ActualiteArticleList mode="decrypt_rhs" {...props} />;
export const DecryptRHArticleCreate = (props) => <ActualiteArticleCreate mode="decrypt_rhs" {...props} />;
export const DecryptRHArticleEdit = (props) => <ActualiteArticleEdit mode="decrypt_rhs" {...props} />;
export const DecryptRHRubriqueList = (props) => <ActualiteRubriqueList mode="decrypt_rhs" {...props} />;
export const DecryptRHArticleShow = (props) => <ActualiteArticleShow mode="decrypt_rhs" {...props} />;
export const DecryptRHRubriqueCreate = (props) => <ActualiteRubriqueCreate mode="decrypt_rhs" {...props} />;
export const DecryptRHRubriqueEdit = (props) => <ActualiteRubriqueEdit mode="decrypt_rhs" {...props} />;
export const DecryptRHTagCreate = (props) => <TagCreate backUrl="/decrypt_rhs/tags" {...props} />;
export const DecryptRHTagEdit = (props) => <TagEdit backUrl="/decrypt_rhs/tags" {...props} />;
export const DecryptRHTagList = (props) => (
    <TagList
        createUrl="/decrypt_rhs/tags/create"
        editUrl={(t) => `/decrypt_rhs/tags/edit/${t.id}`}
        backUrl="/decrypt_rhs"
        {...props}
    />
);